import React, { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient'; // adjust path if needed
import { FiCheckCircle, FiAlertCircle, FiLoader } from 'react-icons/fi';

function ConfirmParticipation() {
  const [status, setStatus] = useState('idle');
  const [loading, setLoading] = useState(false);
  const [visitor, setVisitor] = useState(null);

  // Extract query params from hash (for hash routing)
  let reference = null;
  if (window.location.hash) {
    const hash = window.location.hash.replace('#', '');
    const [, queryString] = hash.split('?');
    if (queryString) {
      const params = new URLSearchParams(queryString);
      reference = params.get('ref');
    }
  }

  // Fetch visitor info on mount if reference exists
  useEffect(() => {
    const fetchVisitor = async () => {
      if (reference && reference.trim() !== '') {
        try {
          // Use public access for reading visitor info
          const { data, error } = await supabase
            .from('visiteurs')
            .select('nom, prenom')
            .eq('reference_participation', reference)
            .single();
          if (!error && data) {
            setVisitor(data);
          }
        } catch (err) {
          console.log('Error fetching visitor:', err);
        }
      }
    };
    fetchVisitor();
    // eslint-disable-next-line
  }, [reference]);

  const handleConfirm = async () => {
    if (!reference || reference.trim() === '') {
      setStatus('error');
      return;
    }
    setLoading(true);
    
    try {
      // Create a public supabase client or use RPC function for public access
      const { data, error } = await supabase.rpc('confirm_participation_public', {
        ref_param: reference
      });

      if (error) {
        // Fallback to direct update if RPC doesn't exist
        const { error: updateError } = await supabase
          .from('visiteurs')
          .update({ statut: 'email confirme' })
          .eq('reference_participation', reference);
        
        if (updateError) {
          console.error('Update error:', updateError);
          setStatus('error');
        } else {
          setStatus('success');
        }
      } else {
        setStatus('success');
      }
    } catch (err) {
      console.error('Confirmation error:', err);
      setStatus('error');
    }
    
    setLoading(false);
  };

  // Responsive and style overrides
  const containerStyle = {
    maxWidth: 500,
    margin: '60px auto',
    padding: 32,
    textAlign: 'center',
    background: '#fff',
    borderRadius: 0,
    boxShadow: 'none',
    border: '1px solid #002b5b',
    color: '#222',
    width: '90%',
  };

  const buttonStyle = {
    padding: '10px 24px',
    fontSize: 18,
    marginTop: 24,
    background: '#002b5b',
    color: '#fff',
    border: 'none',
    borderRadius: 0,
    cursor: 'pointer',
    width: '100%',
    maxWidth: 320,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
    fontWeight: 600,
    transition: 'background 0.2s',
  };

  const iconStyle = { verticalAlign: 'middle', marginRight: 8, fontSize: 28, color: '#002b5b' };
  const iconWhiteStyle = { ...iconStyle, color: '#fff' };

  return (
    <div style={containerStyle}>
      <style>
        {`
          @media (max-width: 600px) {
            div[style] {
              padding: 16px !important;
              margin: 24px auto !important;
            }
            h2 {
              font-size: 1.3em;
            }
            button {
              font-size: 1em !important;
              padding: 10px 0 !important;
            }
          }
        `}
      </style>
      {status === 'idle' && (
        <>
          <h2 style={{ color: '#002b5b', fontWeight: 700 }}>
            <FiCheckCircle style={iconStyle} />
            Confirmation de présence
          </h2>
          {visitor && (
            <div style={{ marginBottom: 16, fontWeight: 500 }}>
              <span style={{ color: '#002b5b' }}>Pour :</span> {visitor.prenom} {visitor.nom}
            </div>
          )}
          <p>
            Merci de cliquer sur le bouton ci-dessous pour confirmer votre présence.
          </p>
          <div style={{ margin: '16px 0', color: '#444', fontSize: 15, background: '#f9f9f9', padding: 12 }}>
            <strong>Pourquoi confirmer&nbsp;?</strong><br />
            Cette confirmation est essentielle pour permettre une bonne organisation de l'événement&nbsp;: elle nous aide à anticiper le nombre de participants et à préparer les certificats de présence personnalisés.
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
            <button onClick={handleConfirm} disabled={loading} style={buttonStyle}>
              {loading ? (
                <>
                  <FiLoader style={iconWhiteStyle} className="spin" />
                  Confirmation...
                </>
              ) : (
                <>
                  <FiCheckCircle style={iconWhiteStyle} />
                  Confirmer ma présence
                </>
              )}
            </button>
          </div>
        </>
      )}
      {status === 'success' && (
        <div>
          <h2 style={{ color: '#002b5b', fontWeight: 700 }}>
            <FiCheckCircle style={iconStyle} />
            Merci !
          </h2>
          <p>Votre présence a bien été confirmée.<br />Nous avons hâte de vous accueillir !</p>
        </div>
      )}
      {status === 'error' && (
        <div>
          <h2 style={{ color: '#002b5b', fontWeight: 700 }}>
            <FiAlertCircle style={iconStyle} />
            Erreur
          </h2>
          <p>
            Impossible de confirmer votre présence.<br />
            {(!reference || reference.trim() === '') ? (
              <>Lien de confirmation invalide ou manquant.</>
            ) : (
              <>Merci de vérifier votre lien ou de contacter l'organisateur.</>
            )}
          </p>
        </div>
      )}
      <style>
        {`
          .spin {
            animation: spin 1s linear infinite;
          }
          @keyframes spin {
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
}

export default ConfirmParticipation;
